import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0007 0.833328C4.93804 0.833328 0.833984 4.93738 0.833984 9.99999C0.833984 15.0626 4.93804 19.1667 10.0007 19.1667C15.0633 19.1667 19.1673 15.0626 19.1673 9.99999C19.1673 7.56884 18.2015 5.23727 16.4825 3.51818C14.7634 1.7991 12.4318 0.833328 10.0007 0.833328ZM10.9173 13.6667C10.9173 14.1729 10.5069 14.5833 10.0007 14.5833C9.49439 14.5833 9.08398 14.1729 9.08398 13.6667V9.08333C9.08398 8.57707 9.49439 8.16666 10.0007 8.16666C10.5069 8.16666 10.9173 8.57707 10.9173 9.08333V13.6667ZM9.08398 6.33333C9.08398 6.83959 9.49439 7.24999 10.0007 7.24999C10.5069 7.24999 10.9173 6.83959 10.9173 6.33333C10.9173 5.82707 10.5069 5.41666 10.0007 5.41666C9.49439 5.41666 9.08398 5.82707 9.08398 6.33333Z"
	})
});
export default SvgIcInfo;
